import toast from 'react-hot-toast';
import { AlertCircle } from 'react-feather';
import Avatar from '@components/avatar';

const ToastSuccess = ({ message, t }) => {
  return (
    <div className="d-flex">
      <div className="me-1">
        <Avatar
          size="sm"
          color="success"
          icon={<AlertCircle size={12} />}
          onClick={() => toast.dismiss(t.id)}
        />
      </div>
      <div className="d-flex flex-column">
        <div className="d-flex justify-content-between">
          <h6>Exito!</h6>
        </div>
        <span>{message}</span>
      </div>
    </div>
  );
};

export default ToastSuccess;
